export default __webpack_public_path__ + "static/media/card.ba57c77a.png";